import { EventList } from "./EventList";
import { EventRegistry } from "./EventRegistry";

export class UnauthorizedEvent {
    private  eventName = EventList.unauthorized;
    constructor(){
        EventRegistry.fire(this.eventName);
    }
}